import React, { Component } from 'react';
import Login from './pages/Login';
import Main from './layout/Main';
import './App.css';
import injectTapEventPlugin from 'react-tap-event-plugin';

class App extends Component {
  constructor(props) {
    var apiPath = window.location.hostname == "localhost" ? "http://localhost:3001" :
                     window.location.port == "5001" ? "http://200.144.255.249:2001" : 
                     window.location.port == "5000" ? "http://200.144.255.249:3001" : 
                    "https://api.ialumni.com.br";
    
    window.sessionStorage.setItem("apiPath",apiPath);    
    injectTapEventPlugin();
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.state = {};    
  }
  componentWillMount(){
    this.setState({authenticationKey:window.sessionStorage.getItem("authenticationKey")});     
  }
  handleLogin(promisse){
    promisse
      .then((rs) => {        
        if(rs.id){
          window.sessionStorage.setItem("authenticationKey",rs.id);
          this.setState({authenticationKey:rs.id});          
        } else {
          alert("Senha ou usuário inválido");
        }       
      })
      .catch((error) => {        
        console.error(error);
      });    
  }  
  handleLogout(){
    this.setState({authenticationKey:null});    
    window.sessionStorage.setItem("authenticationKey",null);    
  }
  render() {         
    const authenticated = this.state.authenticationKey=="null" ||this.state.authenticationKey==null ?false:true;      
    if(authenticated){      
      return ( <Main style={{height:"100%"}} handleLogout={this.handleLogout}/>);
    } else {      
      return (<Login handleLogin={this.handleLogin}/>);
    }      
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js